import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useCollectionsWithoutRevenue(enabled = true) {
  const { getCollectionsWithoutRevenue } = useApi();
  const { data, isLoading } = useQuery({
    queryKey: ["collectionsWithoutRevenue"],
    queryFn: () => getCollectionsWithoutRevenue(),
    enabled: Boolean(enabled),
  });

  const collectionsWithoutRevenue = data?.data;

  return { data: collectionsWithoutRevenue, isLoading };
}
